import { render, staticRenderFns } from "./FlightTableSkeleton.vue?vue&type=template&id=1baa64cb&scoped=true&"
import script from "./FlightTableSkeleton.vue?vue&type=script&lang=js&"
export * from "./FlightTableSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FlightTableSkeleton.vue?vue&type=style&index=0&id=1baa64cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa64cb",
  null
  
)

export default component.exports